export const MINUTE_IN_MS = 60 * 1000;
export const HOUR_IN_MS = 60 * MINUTE_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;
export const YEAR_IN_MS = 365 * DAY_IN_MS;
export const HOUR_IN_S = 60 * 60;
export const DAY_IN_S = 24 * HOUR_IN_S;
export const YEAR_IN_S = 365 * DAY_IN_S;
